import { render, staticRenderFns } from "./MeetingsForm.vue?vue&type=template&id=6c4f3b38"
import script from "./MeetingsForm.vue?vue&type=script&lang=js"
export * from "./MeetingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports